import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { INCIDENT_API } from "./apiRoutes";

interface mutateProps {
  id: string;
  data: FieldValues;
}

const mutateUpdateIncident = async ({
  id,
  data,
}: mutateProps) => {
  return await axiosAuth.patch(`${INCIDENT_API(data?.communityId)}/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const useUpdateIncidentMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateIncident,
    ...queryParams,
  });

export default useUpdateIncidentMutation;
